// extracted by mini-css-extract-plugin
export default {"content":"LinkRelationalFlagsForm_content__OnYtO","box2":"LinkRelationalFlagsForm_box2__pMioY","button-save":"LinkRelationalFlagsForm_button-save__3PEON"};